import { render, staticRenderFns } from "./requestBaDetail.vue?vue&type=template&id=2b708636&scoped=true"
import script from "./requestBaDetail.vue?vue&type=script&lang=js"
export * from "./requestBaDetail.vue?vue&type=script&lang=js"
import style0 from "./requestBaDetail.vue?vue&type=style&index=0&id=2b708636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b708636",
  null
  
)

export default component.exports